import React from 'react';
import { Column } from '../../hooks/useTablePages';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { format, parseISO } from 'date-fns';
import { Flex } from 'rebass';
import StatusDot, { StatusStyle } from '../Status/StatusDot';
import { WaterService } from './WaterServiceDetail';
import colors from '../../theme/colors';

const columns: Column[] = [
  {
    header: 'Status',
    id: 'status',
    accessor: (row: any) => {
      let style: StatusStyle = 'default';
      switch (row.status) {
        case 'ACTIVE':
          style = 'success';
          break;
        case 'INACTIVE':
          style = 'error';
          break;
      }
      return <StatusDot status={style} mr="1" />;
    },
    stringAccessor: (row: any): string => {
      return constantToLabel(row.status);
    },
    width: 70,
  },
  {
    header: 'Model',
    id: 'model',
    accessor: (assembly: any) => {
      return `${assembly.model.backflowAssemblyMake.name} ${assembly.model.name}`;
    },
    width: 210,
  },
  {
    header: 'Size',
    id: 'size',
    accessor: (assembly: any): string =>
      assembly.size ? assembly.size + '"' : '',
    width: 80,
  },
  {
    header: 'Serial',
    accessor: 'serialNumber',
    width: 100,
  },
  {
    header: 'Type',
    accessor: 'type',
    width: 70,
  },
  {
    header: 'Last Tested',
    id: 'testStatus',
    accessor: (row: WaterService['backflowAssemblies'][0]) => {
      const { lastTest } = row;
      const date =
        row.lastTestDate &&
        !row.lastTestDate.startsWith('00') &&
        format(parseISO(row.lastTestDate), 'M/d/yyyy');

      if (!lastTest?.finalResult || lastTest.finalResult === 'FAIL') {
        return (
          <Flex>
            <StatusDot status="error" mr="1" />
            {date}
          </Flex>
        );
      }

      if (lastTest.initialResult === 'FAIL') {
        return (
          <Flex>
            <StatusDot color={colors.failPass} mr="1" />
            {date}
          </Flex>
        );
      }

      return (
        <Flex>
          <StatusDot status="success" mr="1" />
          {date}
        </Flex>
      );
    },
    stringAccessor: (row: WaterService['backflowAssemblies'][0]): string => {
      return constantToLabel(row.lastTest?.finalResult);
    },
    width: 110,
  },
  {
    header: 'Test Anniversary',
    id: 'testAnniversary',
    accessor: (row: WaterService['backflowAssemblies'][0]) => {
      if (!row.testAnniversary || row.testAnniversary.startsWith('00')) {
        return '';
      }
      return format(parseISO(row.testAnniversary), 'MMM do');
    },
    width: 100,
  },
  {
    header: 'Last Notice',
    id: 'lastNoticeSent.created',
    accessor: (row: WaterService['backflowAssemblies'][0]) => {
      if (!row.lastNoticeSent?.created) {
        return '';
      }
      return format(row.lastNoticeSent?.created, 'M/d/yyyy');
    },
    width: 100,
  },
  {
    header: 'Hazard',
    id: 'hazardType',
    accessor: (row: WaterService['backflowAssemblies'][0]) => {
      return row.hazardType + (row.hazardLevel ? ' - ' + row.hazardLevel : '');
    },
    width: 150,
  },
  {
    header: 'Location',
    accessor: 'location',
    width: 200,
  },
];

export default columns;
